import {takeEvery} from 'redux-saga/effects'
import {
  GET_NOTIFCATION_LOGS,
  GET_NOTIFICATION_LOG,
} from 'setup/redux/Actions/NotificationLog/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  // Category
  yield takeEvery(GET_NOTIFCATION_LOGS, fetchData)
  yield takeEvery(GET_NOTIFICATION_LOG, fetchData)
}

export default dataSaga
